import {Dialog} from '@ariakit/react'
import styled, {css} from 'styled-components'

export const StyledCommandMenuOverlay = styled.div(
    ({theme: {palette, opacities, transition}}) => css`
        background: ${palette.neutral['white']}${opacities[70]};
        backdrop-filter: blur(14px);
        opacity: 0;
        transition: ${transition};

        &[data-enter='true'] {
            opacity: 1;
        }
    `
)

export const StyledCommandMenuDialog = styled(Dialog)(
    ({
        theme: {
            transition,
            palette,
            opacities,
            zIndex: {tooltip: zIndexLayer4}
        }
    }) => css`
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: center;
        height: fit-content;
        top: 10vh;
        left: 50%;
        width: 640px;
        transform: translateX(-50%);
        opacity: 0;
        transition: ${transition};
        border-radius: 8px;
        overflow: hidden;
        outline: 1px solid ${palette.neutral['200']};
        z-index: ${zIndexLayer4};

        &[data-enter='true'] {
            opacity: 1;
            box-shadow: 0 16px 56px ${palette.neutral['500']}${opacities[20]};
        }
    `
)
